import Image from "next/image";

import { Link } from "@/components/link/link.component";
import { RichText } from "@/components/richText/richText.component";
import { Text } from "@/components/text/text.component";

import { GetResourceBySlugQueryResult } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

export const ArticleCard = ({ article }: ArticleCardProps) => {
  const thumbnailUrl = article.featuredImage
    ? urlFor(article.featuredImage).width(640).height(360).url()
    : null;

  return (
    <li className="flex flex-col gap-3">
      <Link
        href={article.slug ?? "#"}
        className="focus-visible:ring-secondary flex flex-col gap-3 rounded-2xl focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none">
        <div className="bg-greyscale-background relative col-span-2 h-44 overflow-hidden rounded-xl object-cover">
          {thumbnailUrl ? (
            <Image
              src={thumbnailUrl}
              alt={article.featuredImage?.alt ?? article.title ?? ""}
              width={640}
              height={360}
              className="h-auto w-full rounded-2xl object-cover"
              sizes="(max-width: 767px) 100vw, (max-width: 1023px) 50vw, 33vw"
            />
          ) : null}
        </div>
        <Text variant="h6" component="h2" className="text-greyscale-headline">
          {article.title}
        </Text>
      </Link>
      {article.shortDescription ? (
        <RichText>{article.shortDescription}</RichText>
      ) : null}
      <Link
        href={article.slug ?? "#"}
        className="text-primary w-fit underline underline-offset-2"
        aria-label={
          article.title ? `Learn more about ${article.title}` : "Learn more"
        }>
        Learn more
      </Link>
    </li>
  );
};

type Resource = NonNullable<GetResourceBySlugQueryResult>;

export type ResourceCategory = Extract<Resource, { _type: "articleCategory" }>;

type ResourceCategoryArticle = NonNullable<
  ResourceCategory["articles"]
>[number];
export type ArticleCardProps = {
  article: ResourceCategoryArticle;
};
